import { Component, OnInit, HostListener } from '@angular/core';
import { MainService } from './services/delavci/main.service';
import { LoginPartnerService } from './services/partner/login-partner/login-partner.service';
import { Constants } from './utils/constants';
import { Router, NavigationEnd } from '@angular/router';
import { UpdatePWAService } from './services/update-pwa.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { HelpdeskService } from './services/delavci/helpdesk.service';
import { contourDensity } from 'd3-contour';
import { HelpersService } from './services/shared/helpers.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'BiluminaWeb';
  public showPadding;
  deferredPrompt: any;
  showButton = false;
  public curHostname;
  constructor(private mainService: MainService, private loginPartnerService: LoginPartnerService,
    private router: Router, public MY_CONSTANTS: Constants, private updatePWAservice: UpdatePWAService,
    private snackbar: MatSnackBar, private helpdeskService: HelpdeskService, private helpersService: HelpersService) {

 }

  ngOnInit() {
    this.router.events.subscribe(this.onUrlChange.bind(this));
    this.setHostnameToLocalstorage();
    this.helpersService.currentHostname.subscribe( data => {

      this.curHostname = data;
    });
    this.mainService.currentUser.subscribe( data => {
      if(data){
        this.setParametersCall(data.sessionUser);
      }
    });
    this.loginPartnerService.currentPartner.subscribe( data =>{
      if(data){
        this.setParametersCall(data.sessionUser);
      }
    });
  }

  setParametersCall(sessionUser) {
    if(JSON.parse(localStorage.getItem('helpdeskParameters')) === null) {
      if(sessionUser) {
       this.getHelpdeskParameters(sessionUser);
      }
    }else if(JSON.parse(localStorage.getItem('helpdeskParameters')).communicationIdChat == null) {
      if(sessionUser) {
        this.getHelpdeskParameters(sessionUser);
       }
    }
  }

  getHelpdeskParameters(sessionUser) {
    console.log('poklice' + sessionUser);
    this.helpdeskService.getHelpdeskParameters(sessionUser).subscribe(data => {
      console.log(data.data);
      this.helpdeskService.changeHelpdeskParameters(data.data);
    });
  }
  onUrlChange(ev) {
    if(ev instanceof NavigationEnd) {
      let url = ev.url;
      this.mainService.changeHref(url);
      if(url == '/login' || url == '/login-partner'){
        this.showPadding = false;
      } else {
        this.showPadding = true;
      }
    }
  }

  //Dinamično nastavi hostname. Npr. BC, bilumina... glede na link, s katerega dostopa. Ta hostname se pa zapiše v API, ko se kličejo servici.
  setHostnameToLocalstorage() {
    if(window.location.hostname != 'localhost'){
      if(this.curHostname != window.location.origin) {
        this.helpersService.changeHostname(window.location.origin);
      }
    } else {
      this.helpersService.changeHostname('https://portal.bilumina.com'); //https://www.nama.si https://www.bilumina.com http://172.200.7.117:5080
    }

  }
/*
  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    console.log(e);
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    this.showButton = true;
  }


  addToHomeScreen() {
    const sb = this.snackbar.open('Do you want to install this App?', 'Install', { duration: 5000 });
    sb.onAction().subscribe(() => {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then(result => {
            if (result.outcome == 'dismissed') {
              console.log('User accepted the A2HS prompt');
            } else {
              console.log('User dismissed the A2HS prompt');
            }
        });
    });
  }*/
}
